var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTradeIn = function SvgTradeIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.44 9.539-1.06 1.039L3 6.289 7.38 2l1.06 1.039-2.556 2.503H15v1.469H5.859L8.44 9.539ZM11.06 17.077l1.06 1.04 4.38-4.29-4.38-4.288-1.06 1.038 2.556 2.504H4.5v1.469h9.141l-2.581 2.527Z",
    fill: "currentColor"
  })));
};
export default SvgTradeIn;